import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'

import { OptimUiSharedModule } from '../../shared/optimus-ui-shared.module';
@Component({
  standalone: true,
  imports: [OptimUiSharedModule, CommonModule],
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  currentYear = new Date().getFullYear()
}
